// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTelegramRouteImport } from './routes/_authenticated/telegram'
import { Route as AuthenticatedSourcesRouteImport } from './routes/_authenticated/sources'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSchedulerRouteImport } from './routes/_authenticated/scheduler'
import { Route as AuthenticatedRulesRouteImport } from './routes/_authenticated/rules'
import { Route as AuthenticatedNewsRouteImport } from './routes/_authenticated/news'
import { Route as AuthenticatedLogsRouteImport } from './routes/_authenticated/logs'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCategoriesRouteImport } from './routes/_authenticated/categories'
import { Route as AuthenticatedApprovalRouteImport } from './routes/_authenticated/approval'
import { Route as AuthenticatedAdminsRouteImport } from './routes/_authenticated/admins'

const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTelegramRoute = AuthenticatedTelegramRouteImport.update({
            id: '/telegram',path: '/telegram',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSourcesRoute = AuthenticatedSourcesRouteImport.update({
            id: '/sources',path: '/sources',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSchedulerRoute = AuthenticatedSchedulerRouteImport.update({
            id: '/scheduler',path: '/scheduler',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedRulesRoute = AuthenticatedRulesRouteImport.update({
            id: '/rules',path: '/rules',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedNewsRoute = AuthenticatedNewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLogsRoute = AuthenticatedLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCategoriesRoute = AuthenticatedCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedApprovalRoute = AuthenticatedApprovalRouteImport.update({
            id: '/approval',path: '/approval',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminsRoute = AuthenticatedAdminsRouteImport.update({
            id: '/admins',path: '/admins',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedAdminsRoute: AuthenticatedAdminsRoute,AuthenticatedApprovalRoute: AuthenticatedApprovalRoute,AuthenticatedCategoriesRoute: AuthenticatedCategoriesRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedLogsRoute: AuthenticatedLogsRoute,AuthenticatedNewsRoute: AuthenticatedNewsRoute,AuthenticatedRulesRoute: AuthenticatedRulesRoute,AuthenticatedSchedulerRoute: AuthenticatedSchedulerRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedSourcesRoute: AuthenticatedSourcesRoute,AuthenticatedTelegramRoute: AuthenticatedTelegramRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,LoginRoute: LoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)